import axios from 'axios';
import { get_base_api_url } from '../conf';

require('dotenv').config();
export const SESSION_LOGIN = 'SESSION_LOGIN';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';

export const setLoginUser = (user, access_token) => (dispatch) =>
  dispatch({
    type: SESSION_LOGIN,
    payload: { user, access_token }
  });

export const setLocalUser = (user) => (dispatch) => {
  dispatch({
    type: SESSION_LOGIN,
    payload: {
      ...user
    }
  });
};

function persistFullSession(user, access_token) {
  localStorage.setItem(
    'userLogd',
    JSON.stringify({ user, access_token })
  );
}

export const logout = () => (dispatch) => {
  sessionStorage.removeItem('mfa_pending_token');
  sessionStorage.removeItem('mfa_phase');
  sessionStorage.removeItem('mfa_login_email');
  localStorage.removeItem('userLogd');
  localStorage.removeItem('SuppliersNew');
  localStorage.removeItem('allColors');
  dispatch({
    type: SESSION_LOGOUT
  });
};

export const login = (user, history) => (dispatch) => {
  callLoginApi(user, (callback) => {
    if (callback.error) {
      dispatch({
        type: SESSION_LOGIN,
        payload: {
          user: {},
          access_token: null,
          loginError: callback.error
        }
      });
      return;
    }
    if (callback.mfaRequired) {
      sessionStorage.setItem('mfa_pending_token', callback.pendingToken);
      sessionStorage.setItem('mfa_phase', callback.mfaPhase || '');
      if (user && user.email) {
        sessionStorage.setItem('mfa_login_email', user.email);
      }
      dispatch({
        type: SESSION_LOGIN,
        payload: {
          user: {},
          access_token: null,
          loginError: null
        }
      });
      const phase = (callback.mfaPhase || '').toLowerCase();
      if (phase === 'enroll') {
        history.push('/auth/login/2fa-setup');
      } else {
        history.push('/auth/login/2fa-verify');
      }
      return;
    }
    persistFullSession(callback.user, callback.access_token);
    dispatch({
      type: SESSION_LOGIN,
      payload: {
        user: callback.user,
        access_token: callback.access_token,
        loginError: null
      }
    });
    history.push('/dashboard');
  });
};

const callLoginApi = (user, callback) => {
  axios
    .post(
      `${get_base_api_url()}/api/auth/login`,
      user,
      { headers: { 'Content-Type': 'application/json' } }
    )
    .then((result) => {
      const data = result.data;
      if (data.requires_two_factor && data.pending_token) {
        return callback({
          user: {},
          access_token: null,
          error: null,
          mfaRequired: true,
          mfaPhase: data.mfa_phase || data.mfaPhase,
          pendingToken: data.pending_token
        });
      }
      if (!data.user) {
        return callback({
          user: {},
          error: !data.mailExist ? 'מייל לא קיים' : 'קרתה שגיאה, נסה שוב'
        });
      }
      const accessToken = data.access_token;
      persistFullSession(data.user, accessToken);
      return callback({
        user: data.user,
        access_token: accessToken,
        error: null
      });
    })
    .catch(() => {
      callback({
        user: {},
        error: 'קרתה שגיאה, נסה שוב'
      });
    });
};

function mfaErrorMessage(status) {
  if (status === 429) {
    return 'יותר מדי ניסיונות. נסי שוב בעוד כרבע שעה.';
  }
  return 'קוד שגוי או שפג תוקף ההתחברות. נסי שוב.';
}

export const completeMfaLogin = (body, history, setErr) => (dispatch) => {
  axios
    .post(`${get_base_api_url()}/api/auth/login/2fa`, body, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((result) => {
      const data = result.data;
      if (!data.user || !data.access_token) {
        if (setErr) setErr('קוד שגוי או שפג תוקף. נסי שוב.');
        return;
      }
      sessionStorage.removeItem('mfa_pending_token');
      sessionStorage.removeItem('mfa_phase');
      persistFullSession(data.user, data.access_token);
      dispatch({
        type: SESSION_LOGIN,
        payload: {
          user: data.user,
          access_token: data.access_token,
          loginError: null
        }
      });
      history.push('/dashboard');
    })
    .catch((err) => {
      const status = err.response && err.response.status;
      if (setErr) setErr(mfaErrorMessage(status));
    });
};

export const enableMfaAndCompleteSession = (
  { secret, totp },
  pendingToken,
  history,
  setErr
) => (dispatch) => {
  axios
    .post(
      `${get_base_api_url()}/api/auth/2fa/enable`,
      { secret, totp },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${pendingToken}`
        }
      }
    )
    .then((result) => {
      const data = result.data;
      if (!data.user || !data.access_token) {
        if (setErr) setErr('קוד שגוי. ודאי שהזנת את הקוד הנכון מהאפליקציה.');
        return;
      }
      sessionStorage.removeItem('mfa_pending_token');
      sessionStorage.removeItem('mfa_phase');
      persistFullSession(data.user, data.access_token);
      dispatch({
        type: SESSION_LOGIN,
        payload: {
          user: data.user,
          access_token: data.access_token,
          loginError: null
        }
      });
      history.push('/dashboard');
    })
    .catch((err) => {
      const status = err.response && err.response.status;
      if (setErr) setErr(mfaErrorMessage(status));
    });
};

export const checkToken = (token) => (dispatch) => {
  callTokenApi(token, (callback) => {
    if (!callback.isValid) {
      localStorage.removeItem('userLogd');
      dispatch({
        type: SESSION_LOGOUT
      });
    }
  });
};

const callTokenApi = (token, callback) => {
  axios
    .post(`${get_base_api_url()}/api/auth/check_token`, { token })
    .then((result) => {
      if (result) {
        return callback({
          isValid: result.data.isValid
        });
      }
    });
};
